export enum BusinessContactBannerType {
    UNKNOWN,
    WAIVERNEEDSSIGNING,
    SENSITIVEDATA,
    WAIVERSIGNEDWHENWAIVERSAREENABLED,
    HASABAND
}